import React from 'react';
import S from './style.js'
import SampleImg from '../../img/sulogo.png'

import PDFVIEWER from './pdfviewer'
function Login(props) {
    return (
        <div>
            {props.panel ? <S.Wrapper>
                <div className="logintasi">
                    <div className="logindash">
                        <h1>
                            GİRİŞ
                        </h1>
                        <input type="text" onChange={props.handleChangeUser} placeholder="Kullanıcı Adı" />
                        <input type="password" onChange={props.handleChangePass} placeholder="Şifre" />
                        <input type="submit" value="Giriş" onClick={props.handleLogin} />
                        <div className="logindurum">{props.logindurum}</div>
                        <div className="logo"><img src={SampleImg} alt="" /></div>
                    </div>
                </div>
            </S.Wrapper> : <S.Wrapper>
                <div className="slogan">Dürüstlükle verilen söz, Özveriyle sonuçlanan analiz...</div>
                {/* <div className="girismetni">{props.girisMetni}<br></br><br></br>Örnek;<br></br><img src={SampleImg} alt="" /></div> */}
                <div style={{ height: '400px', display: 'flex', flexDirection: 'column', alignItems: 'center', overflow: 'auto' }}>

                    <PDFVIEWER/>
                </div>
            </S.Wrapper>}
        </div>
    );
}

export default Login;